<template>
  <div class="relative h-40 overflow-hidden rounded-md">
    <img
      class="h-full w-full object-cover"
      :src="
        value.photo_url.includes('data') ||
        value.photo_url.includes('/uploads/')
          ? value.photo_url
          : `/uploads/${value.photo_url}`
      "
      :alt="__('Media image')"
    />

    <button
      class="absolute inset-0 flex items-center justify-center bg-zinc-800/75 opacity-0 transition-opacity hover:opacity-100 focus:opacity-100"
      type="button"
      :aria-label="__('Delete')"
      @click="handleDeleteButtonClick"
    >
      <Icon class="text-xl text-white" name="delete" />
    </button>
  </div>
</template>

<script setup>
  import { Icon } from '@/components/block/icon';

  defineProps({
    value: {
      type: Object,
      required: true
    }
  });

  const emits = defineEmits(['delete']);

  function handleDeleteButtonClick() {
    emits('delete');
  }
</script>
